import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    CustomerSubscription,
    CustomerSubscriptionStatus,
    SubscriptionItem
} from '../types';
import {
    useNavigate,
    useParams
} from "react-router-dom";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<CustomerSubscription, 'id'>,
    handleSubmit: (values: CustomerSubscription) => void
}) => {

    const params = useParams();
    const {id: customerId} = params;
    
    console.log('All params:', params);
    console.log('Extracted customerId:', customerId);

    const navigate = useNavigate()

    const onSubmit = (values: CustomerSubscription) => {
        console.debug('Form values before processing:', values);
        
        if (values.items?.items) {
            values.items.items = values.items.items.map((item: any) => {
                return {
                    id: item.id || '',
                    subscriptionId: values.id || '',
                    priceId: item.priceId,
                    quantity: Number(item.quantity)
                } as SubscriptionItem
            });
        }
        
        console.debug('Form values after processing:', values);
        handleSubmit(values);
        navigate(`/customers/${customerId}`);
    };

    const onCancel = () => {
        console.debug('onCancel - customerId:', customerId);
        console.debug('onCancel - all params:', params);
        const targetUrl = `/customers/${customerId}`;
        console.debug('Navigating to:', targetUrl);
        navigate(targetUrl);
    };


    let initialValues = {
        customerId: customerId,
        items: { items: [], nextToken: undefined },
        status: CustomerSubscriptionStatus.Active
    } as any as CustomerSubscription;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
